module.exports = __webpack_public_path__ + "img/program-neossetup.ba281311.jpg";